<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>施工管理</el-breadcrumb-item>
                <el-breadcrumb-item>风险场所</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
            <div class="build-bar">
                <span>名称:</span>
                <el-input placeholder="请输入风险场所名称" v-model="workPlace"></el-input>
                <el-button type="primary" icon="el-icon-search" @click="doFilter">查询</el-button>
                <el-button type="primary" @click="addRow()">添加</el-button>
                <!-- <el-button type="success" @click="handleEdit">参数配置</el-button> -->
            </div>
            <div class="main-table">
                <el-table :data="tableDataEnd" height="100%" style="width: 100%" :header-cell-style="{background:'#F5F7F9',color:'#909399'}">
                    <template slot="empty">
                        <p>{{dataText}}</p>
                    </template>
                    <el-table-column label="序号" type="index" width="100"></el-table-column>
                    <!-- <el-table-column label="编号">
                        <template slot-scope="scope">
                            <span class="color5" >{{scope.row.sn}}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="风险场所名称">
                        <template slot-scope="scope">
                            <span>{{ scope.row.workPlace }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label=" 注意事项">
                        <template slot-scope="scope">
                        <span>{{ scope.row.attendMatters }}</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column label="有效期">
                        <template slot-scope="scope">
                        <span>{{scope.row.managerName}}</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="风险等级">
                        <template slot-scope="scope">
                        <span v-if=" scope.row.riseLevel==0">低风险</span>
                        <span v-else-if="scope.row.riseLevel==1">低风险</span>
                        <span v-else>高风险</span>
                        </template>
                    </el-table-column>
                   <el-table-column label="图片">
                         <template slot-scope="scope">
                            <el-image v-if="scope.row.thumbnailUrl!=''" style="width: 5vh; height: 5vh;cursor: pointer;" :src="http+scope.row.thumbnailUrl" :preview-src-list="scope.row.srcList"></el-image>
                            <img v-else src="../../../assets//image/zanwutupian.png" style="width: 5vh; height: 5vh;cursor: pointer;" />
                         </template>
                    </el-table-column>
                    <el-table-column label="操作" width="400">
                        <template slot-scope="scope">
                            <el-button size="mini" v-if="isMenuExit('pro:elebox:edit')" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                            <el-button size="mini" v-if="isMenuExit('pro:elebox:del')" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                            <el-button size="mini" @click="erCode(scope.$index, scope.row)">二维码</el-button>
                            <el-button size="mini" type="success" @click="history(scope.$index, scope.row)">历史记录</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <!-- 表单列表 -->
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[5, 10, 20, 50]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalItems"
                ></el-pagination>
            </div>
        </div>
        <!-- 新增窗口 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="addVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            class="add-form"
            width="30%"
        >
            <el-form
            :model="addForm"
            ref="addForm"
            label-width="200px"
            :label-position="labelPosition"
            :rules="rules"
            >
                <el-form-item label="风险场所名称">
                  <el-input v-model="addForm.workPlace" placeholder="请输入风险场所名称" autocomplete="off" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item label=" 注意事项" prop="attendMatters">
                  <el-input type="textarea"  v-model="addForm.attendMatters" placeholder="请输入 注意事项" autocomplete="off" style="width:200px"></el-input>
                </el-form-item>
                <el-form-item label="风险等级">
                      <el-select v-model="addForm.riseLevel" >
                        <el-option
                            v-for="item in level"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                        </el-select>
                </el-form-item>
                  <el-form-item label="图片:">
                <el-upload
                  class="avatar-uploader"
                  v-bind:action="uploadUrl1"
                  :headers="uploadHead1"
                  :data="{type:231}"
                  :show-file-list="false"
                  :on-success="handleIconSuccess"
                >
                  <img v-if="icon" :src="icon" class="avatar" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </el-form-item>
                <!-- <el-form-item label="备注：">
                    <el-input v-model="addForm.remarks" placeholder="备注" autocomplete="off"></el-input>
                </el-form-item> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
            <el-button @click="addVis = false">取 消</el-button>
            <el-button type="primary" @click="sumbitAddRow('addForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 二维码弹出框 -->
        <el-dialog
            :title="codeTit"
            :visible.sync="codeVis"
            center
            :append-to-body="true"
            :lock-scroll="false"
            width="30%"
            style="height:100%;"
        >
            <div class="erCode">
                <vue-qr :text="codeUrl" :size="200"></vue-qr>
                <!-- <p style="width:100%;text-align:center;">
                    <el-button type="primary" @click="downCode">确 定</el-button>
                </p> -->
            </div>
        </el-dialog>
    </div>
</template>

<script>
import myHttp from '../../../untils/port'
import util from '../../../untils/util'
import vueQr from 'vue-qr'
import base from '../../../untils/base'
export default {
    components: {
            vueQr
    },
    data(){
        return{
            tableSn:'',
            tableDataEnd:[],
            currentPage:1,
            pageSize:10,
            totalItems:0,
            groupId:'',
            dataText:'数据加载中...',
            addVis:false,
            dialogTitle:'',
            labelPosition:'right',
            addForm:{
                id:'',
                projectId:'',
                workPlace:'',
                attendMatters:'',
                riseLevel:'',
                 photoUrl:'',
                 thumbnailUrl:''
            },
              uploadUrl1: myHttp.uploadPhotosAndThumbnail, //上传地址
            uploadHead1: {
                accessToken: util.session.get('token')
            },
            rules:{
                sn: [{ required: true, message: '请输入设备序列号', trigger: 'blur' }]
            },
            //二维码
            codeVis:false,
            codeUrl:'',
            codeTit:'',
            level:[{name:"低风险",id:"0"},{name:"中风险",id:"1"},{name:"高风险",id:"2"}],
            icon:'',//配电箱图
            http:base.httpCtx,
            workPlace:''
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.addForm.projectId = this.groupId
        this.getData()
    },
    methods:{
        getData(){
            var that = this
            myHttp.riskPlacePage({
                workPlace:this.workPlace,
                projectId:this.groupId,
                pageNum:this.currentPage,
                pageSize:this.pageSize
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
                        list[i].thumbnailUrl = list[i].thumbnailUrl && list[i].thumbnailUrl!=''?list[i].thumbnailUrl:''
                        list[i].srcList = list[i].thumbnailUrl && list[i].thumbnailUrl!=''?[base.httpCtx+list[i].thumbnailUrl]:[]
                    }
                    that.tableDataEnd = list
                    that.totalItems = resp.data.data.pageInfo.total
                    if (that.tableDataEnd.length == 0) {
                        that.dataText = '暂无数据'
                    }
                }else{
                    that.dataText = '暂无数据'
                }
            })
        },
        handleSizeChange(val) {
          this.pageSize = val
          this.handleCurrentChange(this.currentPage)
        },
        handleCurrentChange(val) {
          console.log(`当前页: ${val}`)
          this.currentPage = val
          this.getData()
        },
        // 监控当前页码
        currentChangePage() {
          this.getData()
        },
        //查询
        doFilter(){
            this.currentPage = 1
            this.getData()
        },

        //添加
        addRow(){
            this.addVis = true
            this.addForm.id = ''
            this.addForm.workPlace = ''
            this.addForm.attendMatters = ''
            this.addForm.riseLevel = ''
            this.icon='',
            this.dialogTitle = '添加'
        },
        //编辑
        handleEdit(index,row){
            this.addVis = true
            this.addForm.id = row.id
            this.addForm.workPlace = row.workPlace
            this.addForm.attendMatters = row.attendMatters
            this.addForm.riseLevel = row.riseLevel
                 this.addForm.photoUrl =row.photoUrl
            this.addForm.thumbnailUrl =row.thumbnailUrl
            this.dialogTitle = '修改'
              this.icon =row.thumbnailUrl && row.thumbnailUrl != '' ? base.httpCtx + row.thumbnailUrl: ''
        },
        //删除
        handleDelete(index,row){
            var that = this
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                myHttp.deleteInfoRisk({
                    id: row.id,
                    updateBy:util.session.get('user').id
                }).then(function(resp) {
                    if (resp.data.code == '200') {
                        that.$message.success('删除成功')
                        that.getData()
                    } else {
                        that.$message.error(resp.data.msg)
                    }
                })
            })
        },
        //提交
        sumbitAddRow(formName){
            var that = this
            this.$refs[formName].validate(valid => {
                if (valid) {
                    //console.log(that.addForm.id)
                    if(that.addForm.id==''){
                        that.addForm.createBy = util.session.get('user').id
                        myHttp.createInfoRiskPlace(that.addForm).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('添加成功')
                                    that.addVis = false
                                    that.currentPage = 1
                                    that.getData()
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                    }else{
                        that.addForm.updateBy = util.session.get('user').id
                        myHttp.updateInfoRisk(that.addForm).then(
                            function(resp) {
                                if (resp.data.code == '200') {
                                    that.$message.success('修改成功')
                                    that.addVis = false
                                    that.getData()
                                } else {
                                    that.$message.error(resp.data.msg)
                                }
                            },
                            function() {}
                        )
                    }
                }
            })
        },

        //展示二维码
        erCode(index,row){
            this.codeVis = true
            var obj=  {
               type:4, //风险
               id:row.id,
               projectId:this.groupId,
               path:'/pages/riskSign/riskSign?id='+row.id+'&projectId='+this.groupId
              }
            this.codeUrl=JSON.stringify(obj)    
            // this.codeUrl = '/pages/riskSign/riskSign?id='+row.id+'&projectId='+this.groupId
            this.codeTit = row.workPlace
        },

        /**
         * 判断是否展示
         */
        isMenuExit(row){
            // var flag = util.common.filterBtnMenu(row)
            // return flag
            return true
        },

        /**
         * 获取历史记录
         */
        history(index,row){
            this.$router.push({ path: '/riskHistory/'+row.id })
        },
               // 上传图片
    handleIconSuccess(res, file) {
      this.icon = URL.createObjectURL(file.raw)
      console.log(res.data)
      this.addForm.photoUrl = res.data.savePhotoUrls
      this.addForm.thumbnailUrl =res.data.saveThumbnailUrls
    },

    },
}
</script>

<style scoped>
    .main{
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .main-table{
        width: 100%;
        height: calc( 100% - 11.4vh );
    }
    .build-bar {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 6vh;
        border-bottom: 3px solid #17b2fe;
        background: #fff;
    }

    .build-bar span {
        margin-left: 30px;
        white-space: nowrap;
        display: inline-block;
    }

    .build-bar > .el-input {
        width: 200px;
        font-size: 12px;
    }
    .build-bar > .el-button {
        margin-left: 30px;
        /* background-color: #17b2fe;
        border-color: #17b2fe; */
    }
    .erCode{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        flex-wrap: wrap;
    }
    .avatar{
    width: 100%;
}
</style>

<style>
    @import '../../../assets/css/common.css'
</style>